import { lazy } from 'react';

const ArchiveEdit = lazy(() => import('./ArchiveEdit'));

export default ArchiveEdit;
